<div class="business-card-page" [class.embedded-mode]="embeddedInDetail" [testId]="'business-card-container'" *ngIf="businessCardForm">
  <div class="page-topbar">
    <div class="page-toolbar" [testId]="'business-card-header'">
      <div class="page-heading">
        <h3 class="page-title" [testId]="'business-card-title'">{{ 'servicenumber.business-card.title' | i18n }}</h3>
      </div>
      <div class="page-actions" [testId]="'business-card-actions'">
        <button
          nz-button
          [nzType]="hasUnsavedChanges ? 'primary' : 'default'"
          class="save-button"
          (click)="saveBusinessCard()"
          [nzLoading]="submitting"
          [disabled]="!hasUnsavedChanges"
          [testId]="'business-card-save-button'"
        >
          <i nz-icon nzType="save" [testId]="'business-card-save-icon'"></i>{{ 'common.save' | i18n }}
        </button>
      </div>
    </div>

    <div class="unsaved-banner" *ngIf="hasUnsavedChanges" [testId]="'business-card-unsaved-banner'">
      {{ 'servicenumber.config.unsaved-banner' | i18n }}
    </div>
  </div>

  <div class="business-card-layout">
    <div class="settings-area" [testId]="'business-card-settings-area'">
      <form nz-form nzLayout="vertical" [formGroup]="businessCardForm" class="form-container" [testId]="'business-card-form'">
        <div class="settings-surface" [testId]="'business-card-settings-card'">
          <div class="section-block">
            <h4 [testId]="'business-card-basic-info-title'">
              <span class="section-kicker"><i nz-icon nzType="profile" nzTheme="outline"></i></span>
              {{ 'servicenumber.business-card.basic-info' | i18n }}
            </h4>
            <div class="basic-toggle-list" [testId]="'business-card-basic-info-row'">
              <nz-form-item class="basic-toggle-item" [testId]="'business-card-form-item'">
                <nz-form-label nzFor="useTenantName" [testId]="'business-card-tenant-name-label'">{{
                  'servicenumber.business-card.use-tenant-name' | i18n
                }}</nz-form-label>
                <nz-form-control [testId]="'business-card-control'">
                  <nz-switch formControlName="useTenantName" id="useTenantName" [testId]="'business-card-tenant-name-switch'" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item class="basic-toggle-item">
                <nz-form-label nzFor="useServiceName" [testId]="'business-card-service-name-label'">{{
                  'servicenumber.business-card.use-service-name' | i18n
                }}</nz-form-label>
                <nz-form-control>
                  <nz-switch formControlName="useServiceName" id="useServiceName" [testId]="'business-card-service-name-switch'" />
                </nz-form-control>
              </nz-form-item>

              <nz-form-item class="basic-toggle-item">
                <nz-form-label nzFor="useServiceAvatar" [testId]="'business-card-service-avatar-label'">{{
                  'servicenumber.business-card.use-service-avatar' | i18n
                }}</nz-form-label>
                <nz-form-control
                  [nzErrorTip]="!businessCardForm.get('imageUrl')?.value ? ('servicenumber.business-card.upload-required' | i18n) : ''"
                >
                  <nz-switch formControlName="useServiceAvatar" id="useServiceAvatar" [testId]="'business-card-service-avatar-switch'" />
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div class="section-block">
            <h4 [testId]="'business-card-contact-info-title'">
              <span class="section-kicker"><i nz-icon nzType="link" nzTheme="outline"></i></span>
              {{ 'servicenumber.business-card.contact-info' | i18n }}
            </h4>
            <div nz-row [nzGutter]="24" [testId]="'business-card-phone-row'">
              <div nz-col [nzXs]="24" [nzSm]="8" [testId]="'business-card-phone-switch-col'">
                <nz-form-item class="contact-item">
                  <nz-form-label nzFor="useTenantPhone" [testId]="'business-card-phone-label'">{{
                    'servicenumber.business-card.show-phone' | i18n
                  }}</nz-form-label>
                  <nz-form-control>
                    <nz-switch formControlName="useTenantPhone" id="useTenantPhone" testId="business-card-use-tenant-phone-switch" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="16" *ngIf="businessCardForm.get('useTenantPhone')?.value">
                <nz-form-item class="contact-item">
                  <nz-form-label nzRequired nzFor="tenantPhone">{{ 'servicenumber.business-card.phone' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="tenantPhone"
                      id="tenantPhone"
                      [placeholder]="'servicenumber.business-card.phone-placeholder' | i18n"
                      testId="business-card-tenant-phone-input"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="24">
              <div nz-col [nzXs]="24" [nzSm]="8">
                <nz-form-item class="contact-item">
                  <nz-form-label nzFor="useTenantAddress">{{ 'servicenumber.business-card.show-address' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <nz-switch formControlName="useTenantAddress" id="useTenantAddress" testId="business-card-use-tenant-address-switch" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="16" *ngIf="businessCardForm.get('useTenantAddress')?.value">
                <nz-form-item class="contact-item">
                  <nz-form-label nzRequired nzFor="tenantAddress">{{ 'servicenumber.business-card.address' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="tenantAddress"
                      id="tenantAddress"
                      [placeholder]="'servicenumber.business-card.address-placeholder' | i18n"
                      testId="business-card-tenant-address-input"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="24">
              <div nz-col [nzXs]="24" [nzSm]="8">
                <nz-form-item class="contact-item">
                  <nz-form-label nzFor="useWebSite">{{ 'servicenumber.business-card.show-website' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <nz-switch formControlName="useWebSite" id="useWebSite" testId="business-card-use-website-switch" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="16" *ngIf="businessCardForm.get('useWebSite')?.value">
                <nz-form-item class="contact-item">
                  <nz-form-label nzRequired nzFor="webSite">{{ 'servicenumber.business-card.website' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="webSite"
                      id="webSite"
                      [placeholder]="'servicenumber.business-card.website-placeholder' | i18n"
                      testId="business-card-website-input"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="24">
              <div nz-col [nzXs]="24" [nzSm]="8">
                <nz-form-item class="contact-item">
                  <nz-form-label nzFor="useOther">{{ 'servicenumber.business-card.other-info' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <nz-switch formControlName="useOther" id="useOther" testId="business-card-use-other-switch" />
                  </nz-form-control>
                </nz-form-item>
              </div>

              <div nz-col [nzXs]="24" [nzSm]="16" *ngIf="businessCardForm.get('useOther')?.value">
                <nz-form-item class="contact-item">
                  <nz-form-label nzRequired nzFor="other">{{ 'servicenumber.business-card.other-content' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="other"
                      id="other"
                      [placeholder]="'servicenumber.business-card.other-placeholder' | i18n"
                      testId="business-card-other-input"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>

          <div class="section-block">
            <h4>
              <span class="section-kicker"><i nz-icon nzType="appstore" nzTheme="outline"></i></span>
              {{ 'servicenumber.business-card.button-settings' | i18n }}
            </h4>
            <div nz-row [nzGutter]="24">
              <div nz-col [nzXs]="24" [nzSm]="24">
                <nz-form-item>
                  <nz-form-label nzFor="buttons">{{ 'servicenumber.business-card.buttons' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <nz-checkbox-group formControlName="buttons" [nzOptions]="buttonOptions" />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>

          <div class="section-block">
            <h4>
              <span class="section-kicker"><i nz-icon nzType="picture" nzTheme="outline"></i></span>
              {{ 'servicenumber.business-card.card-image' | i18n }}
            </h4>
            <div nz-row [nzGutter]="24">
              <div nz-col [nzXs]="24" [nzSm]="24">
                <nz-form-item>
                  <nz-form-label nzFor="imageId">{{ 'servicenumber.business-card.background-image' | i18n }}</nz-form-label>
                  <nz-form-control>
                    <div class="card-image-upload">
                      <div class="image-preview" (click)="openAvatarModal()">
                        <ng-container *ngIf="!businessCardForm.get('imageUrl')?.value">
                          <div class="empty-image">
                            <i nz-icon nzType="picture" nzTheme="outline" [testId]="'business-card-picture-icon'"></i>
                            <p>{{ 'servicenumber.business-card.click-upload' | i18n }}</p>
                          </div>
                        </ng-container>
                        <img
                          *ngIf="businessCardForm.get('imageUrl')?.value"
                          [src]="businessCardForm.get('imageUrl')?.value"
                          [alt]="'servicenumber.business-card.background-image' | i18n"
                        />
                        <div class="image-actions">
                          <button nz-button nzType="primary" nzShape="circle" nzSize="small" [testId]="'business-card-upload-button'">
                            <i nz-icon nzType="upload" [testId]="'business-card-upload-icon'"></i>
                          </button>
                        </div>
                      </div>
                      <div class="upload-hint">{{ 'servicenumber.business-card.image-format-hint' | i18n }}</div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="preview-area" [testId]="'business-card-preview-area'">
      <div class="preview-surface" [testId]="'business-card-preview-card'">
        <div class="preview-header">
          <h3 class="preview-title" [testId]="'business-card-preview-title'">
            <span class="section-kicker"><i nz-icon nzType="eye" nzTheme="outline"></i></span>
            {{ 'servicenumber.business-card.preview-title' | i18n }}
          </h3>
        </div>

        <div class="card-preview" [testId]="'business-card-preview'">
          <div class="card-container" [testId]="'business-card-preview-container'">
            <div class="brand-header" [testId]="'business-card-brand-header'">
              <div
                class="avatar"
                *ngIf="businessCardForm.get('useServiceAvatar')?.value && serviceAvatarUrl; else imageDate"
                [testId]="'business-card-avatar'"
              >
                <img
                  [src]="serviceAvatarUrl"
                  [alt]="'servicenumber.business-card.service-avatar' | i18n"
                  [testId]="'business-card-avatar-img'"
                />
              </div>
              <ng-template #imageDate>
                <div class="brand-image" *ngIf="businessCardForm.get('imageUrl')?.value" [testId]="'business-card-brand-image'">
                  <img [src]="businessCardForm.get('imageUrl')?.value" />
                </div>
                <div class="brand-placeholder" *ngIf="!businessCardForm.get('imageUrl')?.value">
                  <span class="placeholder-text">{{ 'servicenumber.business-card.upload-card-image' | i18n }}</span>
                </div>
              </ng-template>
            </div>

            <div class="card-content">
              <div class="company-info">
                <h2 class="company-name" *ngIf="businessCardForm.get('useTenantName')?.value">
                  {{ tenantName }}
                </h2>
                <div class="service-title" *ngIf="businessCardForm.get('useServiceName')?.value">
                  {{ serviceName }}
                </div>
              </div>

              <div class="contact-info">
                <div class="info-item" *ngIf="businessCardForm.get('useTenantAddress')?.value">
                  <img src="assets/images/flexIcon/address.png" alt="Address" />
                  <span>{{ businessCardForm.get('tenantAddress')?.value }}</span>
                </div>
                <div class="info-item" *ngIf="businessCardForm.get('useTenantPhone')?.value">
                  <img src="assets/images/flexIcon/phone.png" alt="Phone" />
                  <span>{{ businessCardForm.get('tenantPhone')?.value }}</span>
                </div>
                <div class="info-item" *ngIf="businessCardForm.get('useWebSite')?.value">
                  <img src="assets/images/flexIcon/website.png" alt="Website" />
                  <span>{{ businessCardForm.get('webSite')?.value }}</span>
                </div>
                <div class="info-item" *ngIf="businessCardForm.get('useOther')?.value">
                  <img src="assets/images/flexIcon/note.png" alt="Other" />
                  <span>{{ businessCardForm.get('other')?.value }}</span>
                </div>
              </div>
            </div>

            <div class="social-buttons">
              <div class="social-btn line">
                <img src="assets/images/channels/icon-im-line.svg" alt="Line" />
              </div>
              <div class="social-btn facebook">
                <img src="assets/images/channels/icon-im-fb.svg" alt="Facebook" />
              </div>
              <div class="social-btn instagram">
                <img src="assets/images/channels/icon-im-ig.svg" alt="Instagram" />
              </div>
              <div class="social-btn globe">
                <img src="assets/images/channels/webchat.jpg" alt="Webchat" />
              </div>
              <div class="social-btn download">
                <img src="assets/images/flexIcon/download.jpg" alt="Download" />
              </div>
              <div class="more-btn">{{ 'servicenumber.business-card.more' | i18n }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<avatar-upload-modal
  [(visible)]="avatarModalVisible"
  [title]="'servicenumber.business-card.background-upload-title' | i18n"
  [uploading]="isAvatarUploading"
  [aspectRatio]="1"
  [resizeToWidth]="300"
  (cancel)="handleAvatarModalCancel()"
  (ok)="handleAvatarCropped($event)"
  [testId]="'business-card-avatar-upload-modal'"
/>
